// src/components/core/HeadersAndFooters/MobileHeaderLeftCluster.jsx
//
// Shared mobile-header LEFT cluster: the OurNet logo + a single pill (context toggle on the feed
// header, Back on the detail header). One implementation, one set of dimensions (tokens.mobileHeader),
// so the logo and pill are byte-identical in size and position across HeaderButtonsFeed and
// HeaderButtonsDetail — eliminating the feed↔article header jump (Mobile Groups, Commit 7).
//
// The pill content/colour/click is injected: the feed passes a context label + switch handler; the
// detail passes the Back label + ArrowLeft icon + back handler. Geometry never differs.

import React from 'react';
import { tokens } from '../../../styles/designTokens';

const MobileHeaderLeftCluster = ({
  pillLabel,
  pillColor,
  pillIcon: Icon = null,
  onPillClick,
  onLogoClick = null
}) => {
  const m = tokens.mobileHeader;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: `${m.clusterGap}px`, flexShrink: 0 }}>
      <img
        src="/images/logos/header-logo.png"
        alt="OurNet"
        onClick={onLogoClick || undefined}
        style={{
          height: `${m.logoHeight}px`,
          width: 'auto',
          flexShrink: 0,
          cursor: onLogoClick ? 'pointer' : 'default'
        }}
      />
      {pillLabel != null && (
        <button
          onClick={onPillClick}
          style={{
            height: `${m.pill.height}px`,
            padding: `0 ${m.pill.paddingX}px`,
            borderRadius: `${m.pill.radius}px`,
            background: pillColor,
            border: 'none',
            color: 'white',
            fontSize: `${m.pill.fontSize}px`,
            fontWeight: m.pill.fontWeight,
            fontFamily: tokens.typography.fontFamily,
            cursor: 'pointer',
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.15)'
          }}
        >
          {Icon && <Icon size={15} strokeWidth={2.5} />}
          {pillLabel}
        </button>
      )}
    </div>
  );
};

export default MobileHeaderLeftCluster;
